// Utilitários puros de UI. Sem dependência de dados.

export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}

// IDs determinísticos o suficiente para uso de UI (mock). Backend gerará os reais.
export function uid(prefix = 'id'): string {
  return `${prefix}_${Math.random().toString(36).slice(2, 10)}`;
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  const kb = bytes / 1024;
  if (kb < 1024) return `${kb.toFixed(1)} KB`;
  return `${(kb / 1024).toFixed(1)} MB`;
}

// Custos são contabilizados em USD. Mostra mais casas para valores pequenos
// (ex.: $0.0002) e 2 casas para montantes maiores (ex.: $5,000.00).
// Valores monetários sempre com 4 casas decimais — custos de uso são pequenos
// (frações de centavo), então 4 casas tornam as variações visíveis.
export function formatUSD(value: number): string {
  return value.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  });
}

// Alias legado para não quebrar imports antigos (representa USD agora).
export const formatBRL = formatUSD;

export function formatRelativeTime(iso: string, now: Date = new Date()): string {
  const then = new Date(iso).getTime();
  const diff = now.getTime() - then;
  const sec = Math.round(diff / 1000);
  if (sec < 60) return 'agora mesmo';
  const min = Math.round(sec / 60);
  if (min < 60) return `há ${min} min`;
  const hr = Math.round(min / 60);
  if (hr < 24) return `há ${hr} h`;
  const days = Math.round(hr / 24);
  if (days < 30) return `há ${days} d`;
  return new Date(iso).toLocaleDateString('pt-BR');
}

export function formatDuration(ms?: number): string {
  if (ms == null) return '—';
  if (ms < 1000) return `${ms} ms`;
  const sec = ms / 1000;
  if (sec < 60) return `${sec.toFixed(1)} s`;
  const min = Math.floor(sec / 60);
  return `${min}m ${Math.round(sec % 60)}s`;
}

export function nowIso(): string {
  return new Date().toISOString();
}
